import { render, staticRenderFns } from "./ques12.vue?vue&type=template&id=5f34bce2&scoped=true"
import script from "./ques12.vue?vue&type=script&lang=js"
export * from "./ques12.vue?vue&type=script&lang=js"
import style0 from "./ques12.vue?vue&type=style&index=0&id=5f34bce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f34bce2",
  null
  
)

export default component.exports